import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { alpha, makeStyles, Theme } from '@material-ui/core/styles'
import { processEnv } from 'components/configuration/environmentVariables'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    menuItem: {
        fontSize: pxToRem(16),
        '&:hover': {
            backgroundColor: alpha('#29e3bf', 0.2),
            cursor: 'pointer',
        },
    },
}))

export enum BadgelessListingStatus {
    InReview = 'In Review',
    BPMSubmitted = 'BPM Submitted',
    Completed = 'Completed',
    Deprecated = 'Deprecated',
}

export enum ListingStatus {
    PremiumReview = 'Premium Review',
    PremiumReviewBPMSubmitted = 'Premium Review - BPM Submitted',
    PremiumMasterSpecReview = 'Premium MasterSpec Review',
    PremiumMasterSpecReviewBPMSubmitted = 'Premium MasterSpec Review - BPM Submitted',
    InReview = 'In Review',
    BPMSubmitted = 'BPM Submitted',
    ProprietaryReview = 'Proprietary Review',
    ProprietaryReviewBPMSubmitted = 'Proprietary Review - BPM Submitted',
    Completed = 'Completed',
    Deprecated = 'Deprecated',
}


export const AUTOGEN_ELIGIBLE_STATUSES: ReadonlySet<string> = new Set<ListingStatus>([
    ListingStatus.Completed,
    ListingStatus.PremiumMasterSpecReview,
    ListingStatus.PremiumMasterSpecReviewBPMSubmitted,
    ListingStatus.BPMSubmitted,
    ListingStatus.InReview,
])

export interface ListingStatusVariantProps {
    onChange?: (value: string) => void
    hideDeprecated?: boolean
}

const ListingStatusVariant: React.FC<ListingStatusVariantProps> = ({
    onChange,
    hideDeprecated,
}) => {
    const classes = useStyles()

    const filteredStatuses = React.useMemo(() => {
        if (processEnv.REACT_APP_EnableBadgelessCards === '1') {
            return Object.values(BadgelessListingStatus)
        } else {
            return Object.values(ListingStatus).filter(
                (status) =>
                    status !== ListingStatus.InReview &&
                    status !== ListingStatus.BPMSubmitted
            )
        }
    }, [])

    const handleChange = (value: string) => () => {
        onChange?.(value)
    }

    return (
        <List data-testid={'optionList'}>
            {Object.values(filteredStatuses).map(
                (status: ListingStatus, index: number) => {
                    return (
                        (status !== ListingStatus.Deprecated ||
                            !hideDeprecated) && (
                            <ListItem
                                key={`${index}ListingStatus`}
                                className={classes.menuItem}
                                onClick={handleChange(status)}
                                data-testid={`${index}ListingStatus`}
                            >
                                {status}
                            </ListItem>
                        )
                    )
                }
            )}
        </List>
    )
}

export default ListingStatusVariant
